// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchFilterWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}
.searchFilterWrapper > h4 {
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0em;
}
.searchFilterWrapper .searchbarWrapper .ant-input-affix-wrapper {
  border-color: #eeeeeeee !important;
  border-radius: 12px !important;
}
.searchFilterWrapper .searchbarWrapper .ant-input-affix-wrapper input::placeholder {
  color: #00000080;
  font-weight: 500;
}
.searchFilterWrapper .ant-select {
  min-width: 220px;
}
.searchFilterWrapper .ant-select .ant-select-selector {
  border-color: #eeeeeeee !important;
  border-radius: 8px !important;
}
@media (max-width: 991px) {
  .topHeader .topheader-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .topHeader .search-filter {
    justify-content: center;
  }
  .topHeader .right-header {
    padding-top: 20px;
  }
  .topHeader .right-header .ant-space {
    flex-direction: column;
  }
  .topHeader .right-header .btnSpace {
    flex-direction: row;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .searchFilterWrapper {
    flex-direction: column;
  }
  .searchFilterWrapper > h4 {
    display: none;
  }
  .searchFilterWrapper .searchbarWrapper {
    margin-right: unset;
    width: 100%;
  }
  .searchFilterWrapper .kl-custom-select-container {
    width: 100%;
  }
  .searchFilterWrapper .ant-select {
    min-width: 250px;
    width: 100%;
  }
  .topHeader .right-header {
    width: 100%;
  }
  .topHeader .right-header .aside {
    flex-direction: column;
  }
  .topHeader .right-header .aside .searchFilterWrapper {
    flex-direction: column;
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper > h4 {
    display: none;
  }
  .topHeader .right-header .aside .searchFilterWrapper .searchbarWrapper {
    margin-right: unset;
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper .kl-custom-select-container {
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper .ant-select {
    min-width: 220px;
    width: 100%;
  }
  .topHeader .right-header .ant-space {
    flex-direction: column;
  }
  .topHeader .right-header .btnSpace {
    flex-direction: row;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .topHeader .kl-custom-heading .title {
    font-size: 22px;
  }
  .topHeader .right-header {
    width: 100%;
    padding-top: 0px;
  }
  .topHeader .right-header .aside {
    flex-direction: column;
  }
  .topHeader .right-header .aside .searchFilterWrapper {
    flex-direction: column;
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper > h4 {
    display: none;
  }
  .topHeader .right-header .aside .searchFilterWrapper .searchbarWrapper {
    margin-right: unset;
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper .kl-custom-select-container {
    width: 100%;
  }
  .topHeader .right-header .aside .searchFilterWrapper .ant-select {
    min-width: 220px;
    width: 100%;
  }
  .topHeader .right-header .aside button {
    width: 100% !important;
  }
  .topHeader .right-header .ant-space {
    flex-direction: column;
  }
  .topHeader .right-header .btnSpace {
    flex-direction: row;
  }
  .searchFilterWrapper {
    flex-direction: column;
  }
  .right-header {
    width: 100%;
    padding-top: 0px;
  }
  .right-header .aside {
    flex-direction: column;
  }
  .right-header .aside .searchFilterWrapper {
    flex-direction: column;
    width: 100%;
  }
  .right-header .aside .searchFilterWrapper > h4 {
    display: none;
  }
  .right-header .aside .searchFilterWrapper .searchbarWrapper {
    margin-right: unset;
    width: 100%;
  }
  .right-header .aside .searchFilterWrapper .kl-custom-select-container {
    width: 100%;
  }
  .right-header .aside .searchFilterWrapper .ant-select {
    min-width: 220px;
    width: 100%;
  }
  .right-header .aside button {
    width: 100% !important;
  }
  .right-header .ant-space {
    flex-direction: column;
  }
  .right-header .btnSpace {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomComponents/CustomGridView/CustomGridView.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AADF;AAHA;EAMI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AATA;EAeM,kCAAA;EACA,8BAAA;AAHN;AAKQ;EACE,gBAAA;EACA,gBAAA;AAHV;AAjBA;EA2BI,gBAAA;AAPJ;AApBA;EA6BM,kCAAA;EACA,6BAAA;AANN;AAwCA;EACE;IAEI,aAAA;IACA,mBAAA;IACA,uBAAA;EAvCJ;EAmCA;IAOI,uBAAA;EAvCJ;EAgCA;IAUI,iBAAA;EAvCJ;EA6BA;IAYM,sBAAA;EAtCN;EA0BA;IAeM,mBAAA;EAtCN;AACF;AA2CA;EACE;IACE,sBAAA;EAzCF;EAwCA;IAGI,aAAA;EAxCJ;EAqCA;IAMI,mBAAA;IACA,WAAA;EAxCJ;EAiCA;IAWI,WAAA;EAzCJ;EA8BA;IAeI,gBAAA;IACA,WAAA;EA1CJ;EA6CA;IAEI,WAAA;EA5CJ;EA0CA;IAIM,sBAAA;EA3CN;EAuCA;IAMQ,sBAAA;IACA,WAAA;EA1CR;EAmCA;IASU,aAAA;EAzCV;EAgCA;IAYU,mBAAA;IACA,WAAA;EAzCV;EA4BA;IAiBU,WAAA;EA1CV;EAyBA;IAqBU,gBAAA;IACA,WAAA;EA3CV;EAqBA;IA8BM,sBAAA;EAhDN;EAkBA;IAiCM,mBAAA;EAhDN;AACF;AAuDA;EACE;IAGM,eAAA;EAvDN;EAoDA;IAOI,WAAA;IACA,gBAAA;EAxDJ;EAgDA;IAUM,sBAAA;EAvDN;EA6CA;IAYQ,sBAAA;IACA,WAAA;EAtDR;EAyCA;IAeU,aAAA;EArDV;EAsCA;IAkBU,mBAAA;IACA,WAAA;EArDV;EAkCA;IAuBU,WAAA;EAtDV;EA+BA;IA2BU,gBAAA;IACA,WAAA;EAvDV;EA2BA;IAgCQ,sBAAA;EAxDR;EAwBA;IAoCM,sBAAA;EAzDN;EAqBA;IAuCM,mBAAA;EAzDN;EA6DA;IACE,sBAAA;EA3DF;EA6DA;IACE,WAAA;IACA,gBAAA;EA3DF;EAyDA;IAII,sBAAA;EA1DJ;EAsDA;IAMM,sBAAA;IACA,WAAA;EAzDN;EAkDA;IASQ,aAAA;EAxDR;EA+CA;IAYQ,mBAAA;IACA,WAAA;EAxDR;EA2CA;IAiBQ,WAAA;EAzDR;EAwCA;IAqBQ,gBAAA;IACA,WAAA;EA1DR;EAoCA;IA0BM,sBAAA;EA3DN;EAiCA;IA8BI,sBAAA;EA5DJ;EA8BA;IAiCI,mBAAA;EA5DJ;AACF","sourcesContent":["@import \"../../../assets/Styles/variables.less\";\n\n.searchFilterWrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n  > h4 {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1;\n    letter-spacing: 0em;\n    // margin-left: auto;\n  }\n  .searchbarWrapper {\n    // margin-right: auto;\n    .ant-input-affix-wrapper {\n      border-color: @border-color !important;\n      border-radius: 12px !important;\n      input {\n        &::placeholder {\n          color: @placeholder;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .ant-select {\n    min-width: 220px;\n    .ant-select-selector {\n      border-color: @border-color !important;\n      border-radius: 8px !important;\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n@media (max-width: 991px) {\n  .topHeader {\n    .topheader-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .search-filter {\n      justify-content: center;\n    }\n    .right-header {\n      padding-top: 20px;\n      .ant-space {\n        flex-direction: column;\n      }\n      .btnSpace {\n        flex-direction: row;\n      }\n    }\n  }\n}\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .searchFilterWrapper {\n    flex-direction: column;\n    > h4 {\n      display: none;\n    }\n    .searchbarWrapper {\n      margin-right: unset;\n      width: 100%;\n    }\n\n    .kl-custom-select-container {\n      width: 100%;\n    }\n\n    .ant-select {\n      min-width: 250px;\n      width: 100%;\n    }\n  }\n  .topHeader {\n    .right-header {\n      width: 100%;\n      .aside {\n        flex-direction: column;\n        .searchFilterWrapper {\n          flex-direction: column;\n          width: 100%;\n          > h4 {\n            display: none;\n          }\n          .searchbarWrapper {\n            margin-right: unset;\n            width: 100%;\n          }\n\n          .kl-custom-select-container {\n            width: 100%;\n          }\n\n          .ant-select {\n            min-width: 220px;\n            width: 100%;\n          }\n        }\n        // button {\n        //   width: 100% !important;\n        // }\n      }\n      .ant-space {\n        flex-direction: column;\n      }\n      .btnSpace {\n        flex-direction: row;\n      }\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .topHeader {\n    .kl-custom-heading {\n      .title {\n        font-size: 22px;\n      }\n    }\n    .right-header {\n      width: 100%;\n      padding-top: 0px;\n      .aside {\n        flex-direction: column;\n        .searchFilterWrapper {\n          flex-direction: column;\n          width: 100%;\n          > h4 {\n            display: none;\n          }\n          .searchbarWrapper {\n            margin-right: unset;\n            width: 100%;\n          }\n\n          .kl-custom-select-container {\n            width: 100%;\n          }\n\n          .ant-select {\n            min-width: 220px;\n            width: 100%;\n          }\n        }\n        button {\n          width: 100% !important;\n        }\n      }\n      .ant-space {\n        flex-direction: column;\n      }\n      .btnSpace {\n        flex-direction: row;\n      }\n    }\n  }\n  .searchFilterWrapper {\n    flex-direction: column;\n  }\n  .right-header {\n    width: 100%;\n    padding-top: 0px;\n    .aside {\n      flex-direction: column;\n      .searchFilterWrapper {\n        flex-direction: column;\n        width: 100%;\n        > h4 {\n          display: none;\n        }\n        .searchbarWrapper {\n          margin-right: unset;\n          width: 100%;\n        }\n\n        .kl-custom-select-container {\n          width: 100%;\n        }\n\n        .ant-select {\n          min-width: 220px;\n          width: 100%;\n        }\n      }\n      button {\n        width: 100% !important;\n      }\n    }\n    .ant-space {\n      flex-direction: column;\n    }\n    .btnSpace {\n      flex-direction: row;\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
